module.exports = __webpack_public_path__ + "static/media/folder-plus.467f70e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/folder-plus.svg
// module id = 7675
// module chunks = 0